var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jumbotron"},[_c('h1',{staticClass:"display-3"},[_vm._v("Not Found")]),_c('hr',{staticClass:"my-4"}),_c('p',[_vm._v("The page you were looking for was not found.")])])
}]

export { render, staticRenderFns }